export const BULK_SELECTION_LIMIT = 150;
